import { Terminal, ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Live Engine", href: "#live-engine" },
  { label: "How it Works", href: "#how-it-works" },
  { label: "Stack", href: "#stack" },
];

export const Nav = () => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-[#e8e8e4] bg-[#f8f8f6]/80 backdrop-blur-xl">
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
      <a data-testid="navbar-brand-logo" href="#top" className="flex items-center gap-3">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#2563eb] shadow-[0_6px_16px_-6px_rgba(37,99,235,0.6)]">
          <Terminal className="h-4 w-4 text-white" strokeWidth={2.5} />
        </span>
        <span className="font-display text-xl font-semibold text-[#0b0f1a]">emergent</span>
        <span className="hidden items-center gap-1.5 rounded-full border border-[#e8e8e4] bg-white px-2.5 py-0.5 font-mono text-[10px] tracking-[0.2em] text-slate-500 sm:inline-flex">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#10b981]" />
          LIVE v2.4
        </span>
      </a>
      <nav className="hidden items-center gap-8 lg:flex">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            className="text-sm font-medium text-slate-500 transition-colors hover:text-[#0b0f1a]"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <a
        data-testid="navbar-cta-button"
        href="https://emergent.sh"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary group inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold"
      >
        Start Building Free
        <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </a>
    </div>
  </header>
);
